module.exports = __webpack_public_path__ + "static/Sonyax48-5350466bb8156104b65d4b2970648b6f.png";